// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrapers {
  animation: fadeIn 0.3s ease-in;
}

/* ── Active Model Status Bar ── */
.model-status-bar {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.8rem;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
}
.model-status-gbm {
  background: rgba(16, 185, 129, 0.08);
  border: 1px solid rgba(16, 185, 129, 0.3);
  color: #86efac;
}
.model-status-lr {
  background: rgba(245, 158, 11, 0.08);
  border: 1px solid rgba(245, 158, 11, 0.3);
  color: #fcd34d;
}
.model-status-fallback {
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #fca5a5;
}
.model-status-icon {
  font-weight: 700;
  flex-shrink: 0;
}
.model-status-name {
  font-weight: 600;
  flex-shrink: 0;
}
.model-status-detail {
  color: inherit;
  opacity: 0.75;
  border-left: 1px solid currentColor;
  padding-left: 0.6rem;
}
.model-status-date {
  opacity: 0.55;
  margin-left: auto;
  font-size: 0.72rem;
}

/* ── Post-Event Refresh banner ── */
.post-event-banner {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  background: linear-gradient(135deg, #1e3a5f 0%, #1a2f4a 100%);
  border: 1px solid #3b82f6;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.5rem;
  box-sizing: border-box;
  max-width: 100%;
}
.post-event-left {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  min-width: 0;
  overflow: hidden;
}
.post-event-icon {
  font-size: 2rem;
  line-height: 1;
  flex-shrink: 0;
}
.post-event-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #f1f5f9;
}
.post-event-subtitle {
  font-size: 0.85rem;
  color: #94a3b8;
  margin-top: 2px;
  overflow-wrap: break-word;
  word-break: break-word;
}
.post-event-row {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  min-width: 0;
  width: 100%;
  flex-wrap: wrap;
}

.post-event-btn {
  flex-shrink: 0;
  white-space: nowrap;
  margin-left: auto;
}

/* ── Flash message ── */
.message {
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  font-weight: 500;
}
.message.success {
  background: #065f46;
  border: 1px solid #10b981;
  color: #d1fae5;
}
.message.error {
  background: #7f1d1d;
  border: 1px solid #ef4444;
  color: #fecaca;
}

/* ── Section: Weekly Workflow ── */
.workflow-section {
  margin-bottom: 1.5rem;
}

.section-header {
  margin-bottom: 1rem;
}

.section-title {
  margin: 0 0 0.25rem;
  font-size: 1.1rem;
  color: #f1f5f9;
}

.section-subtitle {
  font-size: 0.8rem;
  color: #64748b;
}

.workflow-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1rem;
}

/* ── Card shared ── */
.scraper-card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.scraper-card-advanced {
  background: #161f2e;
  border-color: #263347;
}

.scraper-header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.step-badge {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  background: #3b82f6;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
  margin-top: 2px;
}

.scraper-header-text {
  flex: 1 1;
  min-width: 0;
}

.scraper-header-text h3 {
  margin: 0 0 0.2rem;
  font-size: 0.95rem;
  color: #f1f5f9;
}

.scraper-icon {
  font-size: 1.4rem;
  flex-shrink: 0;
}

.when-tag {
  font-size: 0.72rem;
  color: #60a5fa;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.when-tag-dim {
  color: #475569;
}

.scraper-description {
  color: #94a3b8;
  font-size: 0.82rem;
  line-height: 1.5;
  margin: 0;
}

/* ── Status block ── */
.scraper-status {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: auto;
}

.status-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  min-height: 28px;
}

.status-success-time {
  color: #34d399;
  font-size: 0.78rem;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-success-result {
  color: #64748b;
}

.status-never {
  color: #475569;
  font-size: 0.78rem;
  font-style: italic;
}

/* Inline run button */
.btn-inline {
  flex-shrink: 0;
  padding: 0.3rem 1rem;
  font-size: 0.8rem;
}

/* Operation result line */
.op-result {
  font-size: 0.78rem;
  font-family: 'Courier New', monospace;
  padding: 0.4rem 0.6rem;
  border-radius: 6px;
  margin-top: 0.25rem;
  word-break: break-word;
  overflow-wrap: break-word;
}
.op-result-ok {
  color: #86efac;
  background: #052e16;
}
.op-result-err {
  color: #fca5a5;
  background: #450a0a;
}

/* ── Progress bar ── */
.progress-container {
  background: #0f172a;
  border-radius: 4px;
  height: 6px;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #10b981);
  border-radius: 4px;
  transition: width 0.3s;
}

.progress-text {
  font-size: 0.7rem;
  color: #94a3b8;
  margin-top: 0.2rem;
  display: block;
}

@keyframes indeterminate {
  0%   { transform: translateX(-100%); width: 60%; }
  100% { transform: translateX(200%);  width: 60%; }
}

/* ── Advanced (Model Management) ── */
.advanced-section {
  margin-top: 0.5rem;
}

.advanced-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 10px;
  padding: 0.9rem 1.25rem;
  cursor: pointer;
  color: #f1f5f9;
  text-align: left;
  transition: background 0.15s, border-color 0.15s;
}

.advanced-toggle:hover {
  background: #263347;
  border-color: #475569;
}

.advanced-toggle-title {
  font-size: 0.95rem;
  font-weight: 600;
  white-space: nowrap;
}

.advanced-toggle-hint {
  flex: 1 1;
  font-size: 0.78rem;
  color: #64748b;
}

.advanced-chevron {
  font-size: 0.7rem;
  color: #64748b;
  flex-shrink: 0;
}

.advanced-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

/* ── Calibration date pickers ── */
.cal-date-row {
  display: flex;
  gap: 0.75rem;
}

.cal-date-field {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.cal-date-field label {
  font-size: 0.7rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.cal-date-field input[type="date"] {
  padding: 0.4rem 0.5rem;
  background: #0f172a;
  border: 1px solid #475569;
  border-radius: 6px;
  color: #f1f5f9;
  font-size: 0.8rem;
  width: 100%;
  box-sizing: border-box;
}

.cal-date-field input[type="date"]:focus {
  outline: none;
  border-color: #f59e0b;
}

/* ── Database Health diagnostics ── */
.diag-grid {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  background: #0f172a;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  border: 1px solid #1e293b;
}

.diag-row {
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
}

.diag-label {
  font-size: 0.78rem;
  color: #64748b;
  min-width: 120px;
  flex-shrink: 0;
}

.diag-value {
  font-size: 0.78rem;
  font-family: 'Courier New', monospace;
  line-height: 1.4;
}

/* ── Secondary button variant ── */
.btn-secondary {
  background: #334155;
  color: #e2e8f0;
  border: 1px solid #475569;
}

.btn-secondary:hover:not(:disabled) {
  background: #3d4f66;
}

/* ── Walk-Forward Validation results table ── */
.wf-results {
  margin-top: 0.75rem;
}

.wf-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}

.wf-table th,
.wf-table td {
  padding: 0.35rem 0.6rem;
  text-align: center;
  border-bottom: 1px solid #1e293b;
  color: #94a3b8;
}

.wf-table th {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}

.wf-table td:first-child {
  text-align: left;
  font-weight: 600;
  color: #cbd5e1;
}

.wf-table .wf-winner {
  color: #4ade80;
  font-weight: 700;
}

.wf-table .wf-winner-label {
  color: #94a3b8;
  font-size: 0.72rem;
}

.wf-table .wf-error {
  color: #f87171;
  font-style: italic;
}

.wf-table tfoot .wf-avg-row td {
  border-top: 1px solid #334155;
  border-bottom: none;
  font-weight: 700;
  color: #e2e8f0;
  padding-top: 0.5rem;
}

/* ── Step Logs (post-event pipeline) ── */
.step-log-list {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 0.6rem 0.75rem;
  font-size: 0.78rem;
  font-family: 'Courier New', monospace;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
}
.step-log-entry {
  display: grid;
  grid-template-columns: 1rem 140px 36px 1fr;
  gap: 0.4rem;
  align-items: baseline;
}
.step-log-ok .step-log-icon   { color: #34d399; }
.step-log-ok .step-log-name   { color: #94a3b8; }
.step-log-ok .step-log-duration { color: #475569; font-size: 0.7rem; }
.step-log-ok .step-log-result { color: #64748b; }

.step-log-error .step-log-icon   { color: #f87171; }
.step-log-error .step-log-name   { color: #fca5a5; font-weight: 600; }
.step-log-error .step-log-duration { color: #475569; font-size: 0.7rem; }
.step-log-error .step-log-result { color: #f87171; word-break: break-word; }

.step-log-running .step-log-icon { color: #60a5fa; animation: spin 1s linear infinite; display: inline-block; }
.step-log-running .step-log-name { color: #93c5fd; }
.step-log-running .step-log-result { color: #475569; }

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

.op-result-running {
  background: rgba(59, 130, 246, 0.1);
  border-left: 3px solid #3b82f6;
  color: #93c5fd;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  font-size: 0.82rem;
  margin-top: 0.5rem;
}

/* ── Mobile responsive ── */
@media (max-width: 640px) {
  .post-event-banner {
    padding: 1rem;
  }

  .post-event-row {
    flex-wrap: wrap;
  }

  /* Button drops to its own full-width row */
  .post-event-btn {
    width: 100%;
    white-space: normal;
    text-align: center;
  }

  /* Single-column card grids */
  .workflow-grid,
  .advanced-grid {
    grid-template-columns: 1fr;
  }

  /* Step log: drop fixed 140px name column, let it flex */
  .step-log-entry {
    grid-template-columns: 1rem 1fr 30px;
  }

  /* Result spans all columns on narrow screens */
  .step-log-result {
    grid-column: 1 / -1;
    padding-left: 1.4rem;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  .wf-results {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .wf-table {
    min-width: 280px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Scrapers.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;EACb,mCAAmC;EACnC,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,OAAO,2BAA2B,GAAG,UAAU,EAAE;AACnD;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,WAAW;EACX,qBAAqB;AACvB;AACA,gCAAgC,cAAc,EAAE;AAChD,gCAAgC,cAAc,EAAE;AAChD,kCAAkC,cAAc,EAAE,iBAAiB,EAAE;AACrE,gCAAgC,cAAc,EAAE;;AAEhD,mCAAmC,cAAc,EAAE;AACnD,mCAAmC,cAAc,EAAE,gBAAgB,EAAE;AACrE,qCAAqC,cAAc,EAAE,iBAAiB,EAAE;AACxE,mCAAmC,cAAc,EAAE,sBAAsB,EAAE;;AAE3E,mCAAmC,cAAc,EAAE,kCAAkC,EAAE,qBAAqB,EAAE;AAC9G,mCAAmC,cAAc,EAAE;AACnD,qCAAqC,cAAc,EAAE;;AAErD;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,6BAA6B;EAC7B;;IAEE,0BAA0B;EAC5B;;EAEA,wDAAwD;EACxD;IACE,oCAAoC;EACtC;;EAEA,+CAA+C;EAC/C;IACE,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".scrapers {\n  animation: fadeIn 0.3s ease-in;\n}\n\n/* ── Active Model Status Bar ── */\n.model-status-bar {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-size: 0.8rem;\n  margin-bottom: 0.75rem;\n  flex-wrap: wrap;\n}\n.model-status-gbm {\n  background: rgba(16, 185, 129, 0.08);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  color: #86efac;\n}\n.model-status-lr {\n  background: rgba(245, 158, 11, 0.08);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  color: #fcd34d;\n}\n.model-status-fallback {\n  background: rgba(239, 68, 68, 0.08);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #fca5a5;\n}\n.model-status-icon {\n  font-weight: 700;\n  flex-shrink: 0;\n}\n.model-status-name {\n  font-weight: 600;\n  flex-shrink: 0;\n}\n.model-status-detail {\n  color: inherit;\n  opacity: 0.75;\n  border-left: 1px solid currentColor;\n  padding-left: 0.6rem;\n}\n.model-status-date {\n  opacity: 0.55;\n  margin-left: auto;\n  font-size: 0.72rem;\n}\n\n/* ── Post-Event Refresh banner ── */\n.post-event-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  background: linear-gradient(135deg, #1e3a5f 0%, #1a2f4a 100%);\n  border: 1px solid #3b82f6;\n  border-radius: 12px;\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 1.5rem;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n.post-event-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  min-width: 0;\n  overflow: hidden;\n}\n.post-event-icon {\n  font-size: 2rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n.post-event-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #f1f5f9;\n}\n.post-event-subtitle {\n  font-size: 0.85rem;\n  color: #94a3b8;\n  margin-top: 2px;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n.post-event-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  min-width: 0;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.post-event-btn {\n  flex-shrink: 0;\n  white-space: nowrap;\n  margin-left: auto;\n}\n\n/* ── Flash message ── */\n.message {\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n.message.success {\n  background: #065f46;\n  border: 1px solid #10b981;\n  color: #d1fae5;\n}\n.message.error {\n  background: #7f1d1d;\n  border: 1px solid #ef4444;\n  color: #fecaca;\n}\n\n/* ── Section: Weekly Workflow ── */\n.workflow-section {\n  margin-bottom: 1.5rem;\n}\n\n.section-header {\n  margin-bottom: 1rem;\n}\n\n.section-title {\n  margin: 0 0 0.25rem;\n  font-size: 1.1rem;\n  color: #f1f5f9;\n}\n\n.section-subtitle {\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n.workflow-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 1rem;\n}\n\n/* ── Card shared ── */\n.scraper-card {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.scraper-card-advanced {\n  background: #161f2e;\n  border-color: #263347;\n}\n\n.scraper-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.step-badge {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  background: #3b82f6;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 700;\n  margin-top: 2px;\n}\n\n.scraper-header-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.scraper-header-text h3 {\n  margin: 0 0 0.2rem;\n  font-size: 0.95rem;\n  color: #f1f5f9;\n}\n\n.scraper-icon {\n  font-size: 1.4rem;\n  flex-shrink: 0;\n}\n\n.when-tag {\n  font-size: 0.72rem;\n  color: #60a5fa;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.when-tag-dim {\n  color: #475569;\n}\n\n.scraper-description {\n  color: #94a3b8;\n  font-size: 0.82rem;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* ── Status block ── */\n.scraper-status {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: auto;\n}\n\n.status-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  min-height: 28px;\n}\n\n.status-success-time {\n  color: #34d399;\n  font-size: 0.78rem;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.status-success-result {\n  color: #64748b;\n}\n\n.status-never {\n  color: #475569;\n  font-size: 0.78rem;\n  font-style: italic;\n}\n\n/* Inline run button */\n.btn-inline {\n  flex-shrink: 0;\n  padding: 0.3rem 1rem;\n  font-size: 0.8rem;\n}\n\n/* Operation result line */\n.op-result {\n  font-size: 0.78rem;\n  font-family: 'Courier New', monospace;\n  padding: 0.4rem 0.6rem;\n  border-radius: 6px;\n  margin-top: 0.25rem;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n.op-result-ok {\n  color: #86efac;\n  background: #052e16;\n}\n.op-result-err {\n  color: #fca5a5;\n  background: #450a0a;\n}\n\n/* ── Progress bar ── */\n.progress-container {\n  background: #0f172a;\n  border-radius: 4px;\n  height: 6px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6, #10b981);\n  border-radius: 4px;\n  transition: width 0.3s;\n}\n\n.progress-text {\n  font-size: 0.7rem;\n  color: #94a3b8;\n  margin-top: 0.2rem;\n  display: block;\n}\n\n@keyframes indeterminate {\n  0%   { transform: translateX(-100%); width: 60%; }\n  100% { transform: translateX(200%);  width: 60%; }\n}\n\n/* ── Advanced (Model Management) ── */\n.advanced-section {\n  margin-top: 0.5rem;\n}\n\n.advanced-toggle {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 10px;\n  padding: 0.9rem 1.25rem;\n  cursor: pointer;\n  color: #f1f5f9;\n  text-align: left;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.advanced-toggle:hover {\n  background: #263347;\n  border-color: #475569;\n}\n\n.advanced-toggle-title {\n  font-size: 0.95rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.advanced-toggle-hint {\n  flex: 1;\n  font-size: 0.78rem;\n  color: #64748b;\n}\n\n.advanced-chevron {\n  font-size: 0.7rem;\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.advanced-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n/* ── Calibration date pickers ── */\n.cal-date-row {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.cal-date-field {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.cal-date-field label {\n  font-size: 0.7rem;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.cal-date-field input[type=\"date\"] {\n  padding: 0.4rem 0.5rem;\n  background: #0f172a;\n  border: 1px solid #475569;\n  border-radius: 6px;\n  color: #f1f5f9;\n  font-size: 0.8rem;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.cal-date-field input[type=\"date\"]:focus {\n  outline: none;\n  border-color: #f59e0b;\n}\n\n/* ── Database Health diagnostics ── */\n.diag-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  background: #0f172a;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  border: 1px solid #1e293b;\n}\n\n.diag-row {\n  display: flex;\n  align-items: baseline;\n  gap: 0.75rem;\n}\n\n.diag-label {\n  font-size: 0.78rem;\n  color: #64748b;\n  min-width: 120px;\n  flex-shrink: 0;\n}\n\n.diag-value {\n  font-size: 0.78rem;\n  font-family: 'Courier New', monospace;\n  line-height: 1.4;\n}\n\n/* ── Secondary button variant ── */\n.btn-secondary {\n  background: #334155;\n  color: #e2e8f0;\n  border: 1px solid #475569;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #3d4f66;\n}\n\n/* ── Walk-Forward Validation results table ── */\n.wf-results {\n  margin-top: 0.75rem;\n}\n\n.wf-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8rem;\n}\n\n.wf-table th,\n.wf-table td {\n  padding: 0.35rem 0.6rem;\n  text-align: center;\n  border-bottom: 1px solid #1e293b;\n  color: #94a3b8;\n}\n\n.wf-table th {\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n}\n\n.wf-table td:first-child {\n  text-align: left;\n  font-weight: 600;\n  color: #cbd5e1;\n}\n\n.wf-table .wf-winner {\n  color: #4ade80;\n  font-weight: 700;\n}\n\n.wf-table .wf-winner-label {\n  color: #94a3b8;\n  font-size: 0.72rem;\n}\n\n.wf-table .wf-error {\n  color: #f87171;\n  font-style: italic;\n}\n\n.wf-table tfoot .wf-avg-row td {\n  border-top: 1px solid #334155;\n  border-bottom: none;\n  font-weight: 700;\n  color: #e2e8f0;\n  padding-top: 0.5rem;\n}\n\n/* ── Step Logs (post-event pipeline) ── */\n.step-log-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  background: rgba(0, 0, 0, 0.25);\n  border-radius: 8px;\n  padding: 0.6rem 0.75rem;\n  font-size: 0.78rem;\n  font-family: 'Courier New', monospace;\n  overflow: hidden;\n  width: 100%;\n  box-sizing: border-box;\n}\n.step-log-entry {\n  display: grid;\n  grid-template-columns: 1rem 140px 36px 1fr;\n  gap: 0.4rem;\n  align-items: baseline;\n}\n.step-log-ok .step-log-icon   { color: #34d399; }\n.step-log-ok .step-log-name   { color: #94a3b8; }\n.step-log-ok .step-log-duration { color: #475569; font-size: 0.7rem; }\n.step-log-ok .step-log-result { color: #64748b; }\n\n.step-log-error .step-log-icon   { color: #f87171; }\n.step-log-error .step-log-name   { color: #fca5a5; font-weight: 600; }\n.step-log-error .step-log-duration { color: #475569; font-size: 0.7rem; }\n.step-log-error .step-log-result { color: #f87171; word-break: break-word; }\n\n.step-log-running .step-log-icon { color: #60a5fa; animation: spin 1s linear infinite; display: inline-block; }\n.step-log-running .step-log-name { color: #93c5fd; }\n.step-log-running .step-log-result { color: #475569; }\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n.op-result-running {\n  background: rgba(59, 130, 246, 0.1);\n  border-left: 3px solid #3b82f6;\n  color: #93c5fd;\n  padding: 0.5rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.82rem;\n  margin-top: 0.5rem;\n}\n\n/* ── Mobile responsive ── */\n@media (max-width: 640px) {\n  .post-event-banner {\n    padding: 1rem;\n  }\n\n  .post-event-row {\n    flex-wrap: wrap;\n  }\n\n  /* Button drops to its own full-width row */\n  .post-event-btn {\n    width: 100%;\n    white-space: normal;\n    text-align: center;\n  }\n\n  /* Single-column card grids */\n  .workflow-grid,\n  .advanced-grid {\n    grid-template-columns: 1fr;\n  }\n\n  /* Step log: drop fixed 140px name column, let it flex */\n  .step-log-entry {\n    grid-template-columns: 1rem 1fr 30px;\n  }\n\n  /* Result spans all columns on narrow screens */\n  .step-log-result {\n    grid-column: 1 / -1;\n    padding-left: 1.4rem;\n    word-break: break-word;\n    overflow-wrap: break-word;\n  }\n\n  .wf-results {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .wf-table {\n    min-width: 280px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
